export default __webpack_public_path__ + "static/media/SPPL_Financial_March_2026.c1aa3f93.pdf";